import { msGraphPost,msGraphDelete,msGraphGet } from "../graph.general";

async function createFolder(folderName) {
    const apiPath = `/me/drive/root/children`;
    const body = JSON.stringify({
      name: folderName,
      folder: {},
      "@microsoft.graph.conflictBehavior": "rename" // Options: "fail", "rename", "replace"
    });
  
    return msGraphPost(apiPath, body, true, { "Content-Type": "application/json" });
  }


  // DELETE FOLDER AND CONTENTS
async function deleteFolderAndContents(folderPath) {
    const apiPath = folderPath;
    return msGraphDelete(apiPath);
  }
  
  // CONVERT FILE TO PDF
  async function convertFileToPDF(drive_id,file_id) {
    const apiPath = `/drives/${drive_id}/items/${file_id}/content?format=pdf`;
    return msGraphGet(apiPath, true, {}, 2); // response_type = 2 (Blob for file downloads)
  }
  
  export { createFolder, deleteFolderAndContents, convertFileToPDF };

